import styled from 'styled-components'
import { SITE_HEADER_HEIGHT, theme, VerticalSpacer } from '@superhi/design'

export const TopicsWrapper = styled(VerticalSpacer).attrs({
  amount: { small: 8, medium: 8, large: 12 },
})`
  @media ${theme.breakpoints.medium} {
    position: sticky;
    top: ${SITE_HEADER_HEIGHT.medium + 16}px;
  }

  @media ${theme.breakpoints.large} {
    top: ${SITE_HEADER_HEIGHT.large + 24}px;
  }
`

export const TopicsList = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media ${theme.breakpoints.medium} {
    display: block;
  }

  > * {
    &:not(:last-child) {
      margin-right: 16px;

      @media ${theme.breakpoints.medium} {
        margin-right: 0px;
        margin-bottom: 6px;
      }
    }
  }
`
